const { isDefined } = _uo.utility;

import { getActions } from '@builder-legacy/item/actions/utilities';

/**
 * Returns all the actions that PROBABLY run before a specific action.
 * We say "probably" because we're also adding scheduled actions for delayed actions, and
 * delayed actions for scheduled actions, but we're not 100% sure those will be available
 */
const getActionsThatRunBefore = ( actionID ) => {
    // Get the action
    const action = UncannyAutomator.recipe.items[ actionID ];

    // Check if the action is defined
    if ( ! isDefined( action ) ) {
        return [];
    }

    // Array with all the actions
    const actions = [];

    // Get all actions in order
    const instantActions = getActions( { type: 'instant' } );

    // If the action is instant, then return only the actions with a lower priority
    if ( ! ( action.isDelayed || action.isScheduled || action.isDelayedCustom ) ) {
        actions.push(
            ...instantActions.slice( 0, instantActions.findIndex( action => action.id === actionID ) )
        );
    }

    // If it's delayed, push all the scheduled actions, and delayed actions with a lower delay
    if ( action.isDelayed ) {
        // Add all instant actions
        actions.push(
            ...instantActions
        );

        // Add all scheduled actions
        actions.push(
            ...getActions( { type: 'scheduled' } )
        );

        // All delayed actions with a lower delay
        const delayedActions = getActions( { type: 'delayed' } );
        actions.push(
            ...delayedActions.slice( 0, delayedActions.findIndex( action => action.id === actionID ) )
        );
    }

    // If it's scheduled, push all the delayed actions, and scheduled actions with a lower date
    if ( action.isScheduled ) {
        // Add all instant actions
        actions.push(
            ...instantActions
        );
        
        // Add all delayed actions
        actions.push(
            ...getActions( { type: 'delayed' } )
        );

        // All scheduled actions with a lower delay
        const scheduledActions = getActions( { type: 'scheduled' } );
        actions.push(
            ...scheduledActions.slice( 0, scheduledActions.findIndex( action => action.id === actionID ) )
        );
    }

    // If it's delayed custom, push all the delayed actions, and scheduled actions
    if ( action.isDelayedCustom ) {
        // Add all instant actions
        actions.push(
            ...instantActions
        );
        
        // Add all delayed actions
        actions.push(
            ...getActions( { type: 'delayed' } ),
            ...getActions( { type: 'scheduled' } ),
        );
    }

    return actions;
}

export default getActionsThatRunBefore;
